import React, { useEffect, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useContent } from '../hooks/useContent';
import { VCardService } from '../services/vcardService';
import { CONFIG } from '../utils/config';

export default function VCardPicker({ onChange }) {
  const { content } = useContent('vCardPicker'); // <-- nom explicite
  const [vcards, setVcards] = useState([]);
  const [selected, setSelected] = useState('');
  const { isDark } = useTheme();

  useEffect(() => {
    VCardService.list()
      .then(res => setVcards(res.vcards))
      .catch(() => {
        console.error(content?.errorLoad || 'Erreur lors du chargement des VCards');
        setVcards([]);
      });
  }, [content]);

  const handleSelect = e => {
    const uuid = e.target.value;
    setSelected(uuid);
    onChange(uuid ? `${CONFIG.BASE_URL}/vcard/${uuid}` : '');
  };

  const short = uuid => uuid.slice(0, 6);

  if (!content) {
    return (
      <div className="mt-4 animate-pulse">
        <div className={`h-4 w-40 mb-1 rounded ${isDark ? 'bg-dark-600' : 'bg-gray-300'}`} />
        <div className={`h-10 w-full rounded ${isDark ? 'bg-dark-600' : 'bg-gray-300'}`} />
      </div>
    );
  }

  return (
    <div className="mt-4">
      <label
        className={`block mb-1 text-xs tracking-wide font-semibold ${
          isDark ? 'text-gray-300' : 'text-gray-700'
        }`}
      >
        {content.label}
      </label>

      <select
        value={selected}
        onChange={handleSelect}
        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 ${
          isDark
            ? 'bg-dark-700 border-dark-600 text-white'
            : 'bg-white border-gray-300 text-gray-900'
        }`}
      >
        <option value="">{content.placeholder}</option>

        {vcards.map(vc => [vc.data, vc.number]).map(([vc, number]) => (
          <option key={vc.uuid} value={vc.uuid}>
            {[
	      `#${number} | ${vc.data.name}`,
              vc.data.mail || content.noMail,
              vc.data.phone || content.noPhone,
              vc.data.company || content.noCompany,
            ]
              .filter(Boolean)
              .join(' · ')}
          </option>
        ))}
      </select>
    </div>
  );
}
